import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { useTranslation } from '@hooks';
import { getHeaderTitleKey } from '@helpers/headerTitleKey';

const SEO = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const account = useSelector(state => state.account?.account);
    const titleKey = getHeaderTitleKey(pathname, account);
    const title = titleKey ? t(titleKey) : '';

    return <title>{[title, 'Pluspoint'].filter(Boolean).join(' | ')}</title>;
};

export default SEO;
